import { apiDriver } from "../../../../api/api-driver";
// import { CAR_STATUS, TRANSMISSION_TYPE } from '../../../common/utils/static-data';
import { alert } from "../../../../common/utils/alert";
import { emitter } from "../../../../common/utils/emitter";
import moment from "moment";

export const submit = (
  context,
  isModal,
  visiableOkButtonOnModal,
  setCustomerOnModal
) => {
  context.form
    .validateFields()
    .then(async (values) => {
      if (!isModal) {
        emitter.emit("FETCH_LOADING", true);
      } else {
        visiableOkButtonOnModal(true);
      }
      const leftFormState = context.leftForm.state;
      let dto = {
        active: values.driver_account_status,
        address: values.address ? values.address.trim() : null,
        birthdate: values.birthday
          ? values.birthday.startOf("day").valueOf()
          : null,
        branch_id: values.branch === "HN" ? 1 : values.branch === "ĐN" ? 2 : 3,
        card_type: values.card_type,
        code: values.employee_id ? values.employee_id.trim() : null,
        country_code: leftFormState.country_code,
        ddt_certificate: values.certificate,
        department: null,
        driver_license_expiry_date: values.license_exprire
          ? values.license_exprire.startOf("day").valueOf()
          : null,
        driver_license_number: values.number_license
          ? values.number_license
          : null,
        driver_licenses: values.license ? values.license.trim() : null,
        email: values.email ? values.email : null,
        id: context.state.driverIdEdit ? context.state.driverIdEdit : 0,
        id_card: values.indentify_number,
        iso2: leftFormState.iso2,
        know_english: values.has_english,
        mobile: leftFormState.mobile,
        name: values.driver_name.trim(),
        note: values.note ? values.note.trim() : null,
        password:
          context.state.typeOption === "edit" && context.state.checkEditPass
            ? values.password
            : null,
        status:
          values.driver_status === "CDD"
            ? 1
            : values.driver_status === "KTDD"
            ? 0
            : 2,
        unit_operator_id: context.rightForm.state.unit_operator_id
          ? context.rightForm.state.unit_operator_id
          : null,
        user_group_id:
          values.resources === "avis"
            ? 1
            : values.resources === "subcontractor"
            ? 2
            : 3,
        username: values.employee_id,
      };
      if (context.state.typeOption === "create_new") {
        try {
          const result = await apiDriver.createNewDriver(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Thêm tài xế thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      } else {
        try {
          const result = await apiDriver.updateDriver(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Cập nhật tài xế thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      }
    })
    .catch((err) => {});
};

export const driverConvert = async (driver, context) => {
  const newDriver = context.leftForm;
  newDriver.setState({
    country_code: driver.country_code,
    iso2: driver.iso2 ? driver.iso2 : "vn",
    mobile: driver.mobile,
  });
  context.rightForm.setState({
    unit_operator_id: driver.unit_operator_id
      ? driver.unit_operator_id.id
      : null,
  });
  context.form.setFieldsValue({
    employee_id: driver.code ? driver.code : null,
    driver_name: driver.name ? driver.name.trim() : null,
    indentify_number: driver.id_card ? driver.id_card.trim() : null,
    card_type: driver.card_type ? Number(driver.card_type) : null,
    birthday: driver.birthdate ? moment(driver.birthdate) : null,
    address: driver.address ? driver.address.trim() : null,
    mobile: driver.mobile ? `+${driver.country_code}` + driver.mobile : null,
    email: driver.email ? driver.email : null,
    license: driver.driver_licenses ? driver.driver_licenses.trim() : null,
    resources: driver.user_group_id.code,
    branch: driver.branch_id ? driver.branch_id.code : null,
    number_license: driver.driver_license_number
      ? driver.driver_license_number
      : null,
    license_exprire: driver.driver_license_expiry_date
      ? moment(driver.driver_license_expiry_date)
      : null,
    driver_status:
      driver.status === 0 ? "KTDD" : driver.status === 1 ? "CDD" : "DDD",
    driver_account_status: driver.active,
    has_english: driver.know_english ? true : false,
    certificate: driver.ddt_certificate ? true : false,
    note: driver.note ? driver.note.trim() : "",
    manager: driver.unit_operator_id ? driver.unit_operator_id.name : null,
    username: driver.code ? driver.code : null,
  });
};

export const checkDriverType = (title) => {
  return ({ getFieldValue }) => ({
    validator(rule, v) {
      const driver_type = getFieldValue("resources");
      if (driver_type === "customer") {
        if (v && v.length > 100) {
          return Promise.reject(`${title} vượt quá 100 ký tự!`);
        }
        return Promise.resolve();
      } else {
        if (!v) {
          return Promise.reject(
            `Vui lòng nhập ${title.replace(/[:*]/gi, "").trim()}!`
          );
        }
        if (v.length > 100) {
          return Promise.reject(`${title} vượt quá 100 ký tự!`);
        }
        return Promise.resolve();
      }
    },
  });
};
